import React from 'react';
export function FlatForest({
  className = ''
}: {
  className?: string;
}) {
  return <svg width="320" height="260" viewBox="0 0 320 260" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} data-id="element-25">
      {/* Background Glow / Ground */}
      <ellipse cx="160" cy="230" rx="140" ry="20" fill="rgba(197,216,45,0.06)" data-id="element-26" />

      {/* --- TREE 1 (Left, Small) --- */}
      <g transform="translate(-40, 40) scale(0.8)" data-id="element-27">
        {/* Trunk */}
        <rect x="100" y="150" width="16" height="80" rx="4" fill="#5D4037" data-id="element-28" />
        <path d="M100 220 Q 90 230 85 230 L 130 230 Q 125 230 116 220 Z" fill="#5D4037" data-id="element-29" />
        {/* Canopy */}
        <circle cx="110" cy="80" r="35" fill="#8FA320" data-id="element-30" />
        <circle cx="80" cy="110" r="30" fill="#C5D82D" data-id="element-31" />
        <circle cx="140" cy="100" r="32" fill="#A8BF24" data-id="element-32" />
        <circle cx="110" cy="110" r="35" fill="#9DB225" data-id="element-33" />
      </g>

      {/* --- TREE 2 (Center, Large) --- */}
      <g transform="translate(50, 0)" data-id="element-34">
        {/* Trunk */}
        <rect x="100" y="150" width="20" height="90" rx="4" fill="#5D4037" data-id="element-35" />
        <path d="M100 230 Q 90 240 85 240 L 135 240 Q 130 240 120 230 Z" fill="#5D4037" data-id="element-36" />
        {/* Branches */}
        <path d="M110 180 L 80 140" stroke="#5D4037" strokeWidth="8" strokeLinecap="round" data-id="element-37" />
        <path d="M110 160 L 145 120" stroke="#5D4037" strokeWidth="7" strokeLinecap="round" data-id="element-38" />
        {/* Canopy */}
        <circle cx="110" cy="70" r="45" fill="#8FA320" data-id="element-39" />
        <circle cx="70" cy="110" r="40" fill="#C5D82D" data-id="element-40" />
        <circle cx="150" cy="100" r="42" fill="#A8BF24" data-id="element-41" />
        <circle cx="90" cy="145" r="35" fill="#B5C828" data-id="element-42" />
        <circle cx="135" cy="140" r="38" fill="#D4E54A" data-id="element-43" />
        <circle cx="110" cy="110" r="45" fill="#9DB225" data-id="element-44" />
      </g>

      {/* --- TREE 3 (Right, Medium) --- */}
      <g transform="translate(150, 20) scale(0.9)" data-id="element-45">
        {/* Trunk */}
        <rect x="100" y="150" width="18" height="85" rx="4" fill="#5D4037" data-id="element-46" />
        <path d="M100 225 Q 90 235 85 235 L 135 235 Q 130 235 118 225 Z" fill="#5D4037" data-id="element-47" />
        {/* Canopy */}
        <circle cx="110" cy="75" r="40" fill="#A8BF24" data-id="element-48" />
        <circle cx="75" cy="115" r="35" fill="#C5D82D" data-id="element-49" />
        <circle cx="145" cy="105" r="38" fill="#8FA320" data-id="element-50" />
        <circle cx="110" cy="115" r="40" fill="#B5C828" data-id="element-51" />
      </g>
    </svg>;
}